import { Pipe, PipeTransform, inject } from '@angular/core';
import { MissionCurrencyService } from '../services/mission-currency.service';

/** Formatea importes con la moneda de misión (Settings/features). */
@Pipe({ name: 'missionMoney', standalone: true, pure: false })
export class MissionMoneyPipe implements PipeTransform {
  private readonly currency = inject(MissionCurrencyService);

  transform(value: number | null | undefined): string {
    return this.currency.format(value);
  }
}
